import type { ReactNode } from "react";
import { useEffect } from "react";

import { useToast } from "@aviary";
import type { FlashMessage } from "@login/data/types/FlashMessage.d";

interface Props {
  flashMessages: FlashMessage[];
  children: ReactNode;
}

const RailsFlashProvider = ({ flashMessages, children }: Props) => {
  const { makeToast } = useToast();

  const mapRailsTypeToToast = (flashType: string) => {
    switch (flashType) {
      case "danger":
        return "error";
      case "success":
        return "success";
      default:
        return "normal";
    }
  };

  const autoDismiss = (message: string) => {
    return message.includes("You are already signed in.");
  };

  useEffect(() => {
    if (flashMessages && flashMessages.length > 0) {
      flashMessages.map(flash => {
        makeToast(mapRailsTypeToToast(flash.type), flash.message, {
          autoDismiss: autoDismiss(flash.message),
        });
      });
    }
  }, []);

  return <>{children}</>;
};

export { RailsFlashProvider };
